import { render, staticRenderFns } from "./URLShortnerTable.vue?vue&type=template&id=728a1d65"
import script from "./URLShortnerTable.vue?vue&type=script&lang=js"
export * from "./URLShortnerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports